import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { getForm } from '../requests';

type QueryParams = {
  id: string | number;
};

type QueryOptions = {
  enabled?: boolean;
};

export const useGetForm = ({ id }: QueryParams, options?: QueryOptions) => {
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId() as number;

  return useQuery({
    queryKey: [API_QUERY_KEYS.form, { id: Number(id) }],
    queryFn: () =>
      getForm({ pathParams: { organisationId, boardId, formId: id } }),
    ...options,
  });
};
